import { observer } from 'mobx-react'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import {
   REACT_LOADING_DURATION,
   reactLoadingSkeletonTypes
} from '../Loader/constants'
import { FullScreenLoader } from '../LoadingWrapper/LoadingView'

import SlimbarSkeletonLoader from './AppsListLoader'
import BoardsListControllerLoader from './BoardsListControllerLoader'
import HomeBoardLoader from './HomeBoardLoader'
import ListViewLoader from './ListViewLoader'
import { UserCard } from './styledComponents'
import TaskDetailedViewLoader from './TaskDetailedViewLoader'
import { ReactContentLoaderProps } from './types'
import YourProjectsRouteLoader from './YourProjectsRouteLoader'
import YourTeamsRouteLoader from './YourTeamsRouteLoader/YourTeamsRouteLoader'

class ReactLoadingSkeleton extends React.Component<ReactContentLoaderProps> {
   renderDefaultLoader = () => (
      <UserCard>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            count={4}
            width={500}
            height={20}
         />
         <Skeleton height={100} width={500} />
      </UserCard>
   )
   renderSkeletonLoader = () => {
      const { loaderType, pathname } = this.props
      const {
         reactTable,
         kanbanView,
         taskDetailedView,
         boardsListController,
         yourProjectsRoute,
         yourTeamsRoute,
         appsListController,
         homeBoardTasks
      } = reactLoadingSkeletonTypes

      const { renderDefaultLoader: RenderDefaultLoader } = this
      if (pathname) {
         return <FullScreenLoader />
      }

      switch (loaderType) {
         case reactTable:
            return <ListViewLoader {...this.props} />
         case kanbanView:
            return <>KanbanViewLoader</>
         case taskDetailedView:
            return <TaskDetailedViewLoader {...this.props} />
         case boardsListController:
            return <BoardsListControllerLoader {...this.props} />
         case yourProjectsRoute:
            return <YourProjectsRouteLoader {...this.props} />
         case yourTeamsRoute:
            return <YourTeamsRouteLoader {...this.props} />
         case appsListController:
            return <SlimbarSkeletonLoader {...this.props} />
         case homeBoardTasks:
            return <HomeBoardLoader {...this.props} />
         default:
            return <RenderDefaultLoader />
      }
   }
   render() {
      const { renderSkeletonLoader: RenderSkeletonLoader } = this
      return <RenderSkeletonLoader />
   }
}

export default observer(ReactLoadingSkeleton)
